// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__wKnc6","link":"HeaderSimple_link__VLwCz","inputSearch":"HeaderSimple_inputSearch__em5mc"};